import { render, staticRenderFns } from "./deliverGoods.vue?vue&type=template&id=70407bc4&scoped=true&"
import script from "./deliverGoods.vue?vue&type=script&lang=js&"
export * from "./deliverGoods.vue?vue&type=script&lang=js&"
import style0 from "./deliverGoods.vue?vue&type=style&index=0&id=70407bc4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70407bc4",
  null
  
)

export default component.exports